module.exports = __webpack_public_path__ + "static/media/pegasus.a30dff9f.svg";